/**
 * Admin Auth API 封装
 * 提供简洁的 API 命名，封装自动生成的 API
 */
import {
  loginApiAdminAuthLoginPost,
  getMeApiAdminAuthMeGet,
  totpSetupApiAdminAuthTotpSetupPost,
  totpEnableApiAdminAuthTotpEnablePost,
  totpDisableApiAdminAuthTotpDisablePost,
} from '../admin/adminAuth';

export { TOKEN_KEY } from './typings.d';

/**
 * 管理员登录
 * @param body 登录参数 { username, password, totp_code? }
 */
export const adminLogin = loginApiAdminAuthLoginPost;

/**
 * 获取当前管理员信息
 */
export const getAdminInfo = getMeApiAdminAuthMeGet;

/**
 * 获取 TOTP 设置信息（用于绑定验证器）
 */
export const getTOTPSetup = totpSetupApiAdminAuthTotpSetupPost;

/**
 * 启用 TOTP 两步验证
 * @param body { totp_code: string }
 */
export const enableTOTP = totpEnableApiAdminAuthTotpEnablePost;

/**
 * 禁用 TOTP 两步验证
 * @param body { password: string }
 */
export const disableTOTP = totpDisableApiAdminAuthTotpDisablePost;
